<template>
  <a-layout class="height-100">
    <img class="logo logo-center absolute top-0 left-0 m2" src="@/assets/logo.png" />
    <div class="height-100 mobile-card mobile-snap-bottom">
      <a-layout class="height-100">
        <a-layout-content >
          <a-row type="flex" justify="space-around" align="middle" class="height-100" >
            <a-col :span="24" :sm="16" :md="14" :lg="10" class="center">
              <h1 class="white left-align">Forgot Password</h1>
              <a-card class="card left-align">
                <a-form layout="vertical">
                  <a-form-item label="Email">
                    <a-input type="email" v-model="data_email" placeholder="Your email"></a-input>
                  </a-form-item>
                  <a-form-item class="mb0 left">
                    <small><a href="/login">Back to login</a></small>
                  </a-form-item> 
                  <a-form-item class="mb0 right">
                    <a-button size="large" type="primary" :disabled="!comp_isReady" :loading="data_loading" @click="func_onLogin">Reset password<a-icon type="right"/></a-button>
                  </a-form-item>
                </a-form>
              </a-card>
            </a-col>
          </a-row>
        </a-layout-content>
      </a-layout>
    </div>
  </a-layout>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Login',
  data() {
    return {
      data_email: '',
      data_loading: false
    }
  },
  computed: {
    comp_isReady() {
      return this.data_email.length >= 4
    }
  },
  methods: {
    func_onLogin() {
      this.data_loading = true;
      firebase.auth().sendPasswordResetEmail(this.data_email).finally(() => {
        this.data_loading = false;
        this.$message.success('Email send.');
        this.$router.push('login');
      })
    }
  }
}
</script>
